"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=voice.js.map